export default __webpack_public_path__ + "static/media/AutomobileBattery.f3112a63.png";